export default __webpack_public_path__ + "static/media/arrow-green-small.ad47a99c.svg";